import { gql } from '@apollo/client';

export const getPersonDataForMediaInjection = gql`
  query getPersonDataForMediaInjection($personIds: [PersonId!]!) {
    persons(filter: { oid: { _in: $personIds } }) {
      filteredCount
      edges {
        node {
          id
          oid
          firstName
          lastName
          customerReference
          prefixAcademicTitle {
            id
            oid
            name
          }
          postfixAcademicTitle {
            id
            oid
            name
          }
          personTypes {
            edges {
              node {
                id
                oid
                name
                customerReference
                sortCode
              }
            }
          }
          employments {
            edges {
              node {
                function {
                  id
                  oid
                  customerReference
                  name
                }
              }
            }
          }
          specialities {
            edges {
              node {
                sortCode
                speciality {
                  id
                  oid
                  name
                  customerReference
                }
              }
            }
          }
          attributes {
            filteredCount
            edges {
              node {
                attribute {
                  id
                  oid
                  name
                  customerReference
                  type
                  usageType
                  options {
                    id
                    oid
                    customerReference
                    value
                    sequence
                  }
                }
                values {
                  oid
                  booleanValue
                  dateValue
                  documentValue {
                    id
                    oid
                  }
                  numericValue
                  optionValue {
                    id
                    oid
                    value
                    customerReference
                  }
                  textValue
                }
              }
            }
          }
          consents {
            edges {
              node {
                id
                oid
                lifecycleState
                consentType {
                  id
                  oid
                  name
                  customerReference
                  state
                  lifecycleStatus
                }
                consentItemValues {
                  consentItemState
                  consentItem {
                    oid
                    name
                  }
                  communicationDataValues {
                    value
                    consentCommunicationDataType {
                      oid
                      communicationDataType {
                        id
                        oid
                        customerReference
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
